







import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class Button extends Vue {
  @Prop({required: true})
  handleClick: () => null;

  @Prop({required: true})
  title: string;

  @Prop({})
  icon: string;

  @Prop({default: false})
  outlined: boolean;

  @Prop({default: 'primary'})
  color: string;

  @Prop({default: false})
  disabled: boolean;
}
